<template>
    <svg class="icon-twitter fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300.1 271"><path d="M237.1,0h46l-101,115,118,156h-92.6l-72.5-94.8-83,94.8H6l107-123L0,0h94.9l65.5,86.6L237.1,0ZM221,244h25.5L81.5,26h-27.4l166.9,218Z"/></svg>
</template>
